import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-templates')!;

export default function ArticleTemplatesPage() {
  return <ArticleTemplate article={article} />;
}